import { Award, Building, Users, Clock } from "lucide-react";
import { IMAGES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

const STATS = [
  { icon: Clock, value: "~4 Decades", label: "In Kolkata's residential landscape" },
  { icon: Building, value: "45+", label: "Projects delivered" },
  { icon: Award, value: "5.7 Mn sq ft", label: "Under construction" },
  { icon: Users, value: "7000+", label: "Happy residents" },
];

export const Developer = () => (
  <section data-testid="developer-section" className="py-20 sm:py-28 bg-[#EAF5D6] relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <SectionHeading index="08" eyebrow="The Developer" title="About Vinayak Group" dark />
          <Reveal delay={0.15}>
            <p className="mt-6 text-[#4D7C0F] text-base sm:text-lg leading-relaxed max-w-2xl">
              Vinayak Group has been active in Kolkata's residential landscape for nearly four decades, shaping
              neighbourhoods across the city with a focus on dependable delivery and liveable design.
            </p>
          </Reveal>
          <div className="grid grid-cols-2 gap-4 mt-10">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={0.08 * i}>
                <div className="border border-[#84CC16]/30 rounded-xl p-5 bg-[#FFFFFF]" data-testid={`developer-stat-${i}`}>
                  <s.icon size={17} className="text-[#84CC16]" strokeWidth={1.6} />
                  <p className="font-serif-display text-2xl sm:text-3xl text-[#3F6212] mt-3">{s.value}</p>
                  <p className="text-[#65A30D] text-xs mt-1">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <p className="mt-8 text-[13px] text-[#65A30D] leading-relaxed border-l-2 border-[#84CC16]/50 pl-4 max-w-2xl">
              Forest Hill Realtors is the authorised channel partner for Vinayak 21 Acres — not the developer. We
              assist you with transparent information, floor plans, pricing updates and site visits.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="img-frame rounded-sm overflow-hidden">
            <div className="overflow-hidden rounded-sm">
              <img src={IMAGES.terrace} alt="Sky terrace view from a premium Kolkata residence" className="w-full h-[420px] object-cover" loading="lazy" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
